// extracted by mini-css-extract-plugin
export default {"button":"Button_button__I9NM5","invert":"Button_invert__z5L-x","primary":"Button_primary__Af4LM"};